import React from 'react';
import {
  IonButton,
  IonInput,
  IonInputPasswordToggle,
  IonItem,
  IonList,
} from '@ionic/react';
import { useTranslation } from 'react-i18next';
import AppPasswordQuality from '../../components/AppPasswordQuality';
import { cfgPasswordMinLength } from '../../utils/config';
import {uiInputMode} from "../../utils/ui";

type AccountPasswordFormProps = {
  isValid: boolean;
  proceed: () => void;
  old: string;
  setOld: (s: string) => void;
  password: string;
  setPassword: (s: string) => void;
  password2: string;
  setPassword2: (s: string) => void;
};

export default function AccountPasswordForm({
  isValid,
  old,
  setOld,
  password,
  setPassword,
  password2,
  setPassword2,
  proceed,
}: AccountPasswordFormProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <h1 className="h1 mx-auto ion-text-center h1plus">{t('changepw.subtitle')}</h1>
      <p className="pt-2 pb-4 instructions ion-text-center">
        {t('changepw.info')}
      </p>
      <IonList inset={false}>
        <IonItem lines="none" className="ion-no-padding ion-pt-1">
          <IonInput
            className="password"
            value={old}
            mode={uiInputMode()}
            aria-label={t('changepw.old')!}
            placeholder={t('changepw.old')!}
            onIonInput={(e) => setOld(e.detail.value!)}
            type="password"
            fill="outline"
          >
            <IonInputPasswordToggle
              color="secondary"
              slot="end"
            ></IonInputPasswordToggle>
          </IonInput>
        </IonItem>
        <IonItem lines="none" className="ion-no-padding ion-pt-1">
          <IonInput
            className="password"
            value={password}
            mode={uiInputMode()}
            aria-label={t('changepw.password')!}
            placeholder={t('changepw.password')!}
            onIonInput={(e) => setPassword(e.detail.value!)}
            type="password"
            fill="outline"
          >
            <IonInputPasswordToggle
              color="secondary"
              slot="end"
            ></IonInputPasswordToggle>
          </IonInput>
        </IonItem>
        <AppPasswordQuality
          minLength={cfgPasswordMinLength()}
          password={password}
        ></AppPasswordQuality>
        <IonItem lines="none" className="ion-no-padding ion-pt-1">
          <IonInput
            className="password"
            value={password2}
            mode={uiInputMode()}
            aria-label={t('changepw.password2')!}
            placeholder={t('changepw.password2')!}
            onIonInput={(e) => setPassword2(e.detail.value!)}
            type="password"
            fill="outline"
          >
            <IonInputPasswordToggle
              color="secondary"
              slot="end"
            ></IonInputPasswordToggle>
          </IonInput>
        </IonItem>
      </IonList>

      <div className="pt-4 ion-text-center">
        <IonButton
          className={
            'btn-default btn-wide-80 ' + (isValid ? '' : 'btn-disabled')
          }
          onClick={() => proceed()}
        >
          {t('changepw.savechanges')}
        </IonButton>
      </div>
    </>
  );
}
